import { useMainConfig } from "../../../contexts/StoreContext";
import { useTranslation } from "react-i18next";

const FlagES = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500" width="20" height="14">
    <rect width="750" height="500" fill="#c60b1e"/>
    <rect width="750" height="250" y="125" fill="#ffc400"/>
  </svg>
);

const FlagUS = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1235 650" width="20" height="14">
    <rect width="1235" height="650" fill="#B22234"/>
    <rect y="50" width="1235" height="50" fill="white"/>
    <rect y="150" width="1235" height="50" fill="white"/>
    <rect y="250" width="1235" height="50" fill="white"/>
    <rect y="350" width="1235" height="50" fill="white"/>
    <rect y="450" width="1235" height="50" fill="white"/>
    <rect y="550" width="1235" height="50" fill="white"/>
    <rect width="494" height="350" fill="#3C3B6E"/>
  </svg>
);

const LanguageButton = () => {
  const {
    language: stateLanguage,
    actions: { changeLanguage },
  } = useMainConfig();

  const { i18n } = useTranslation();

  const updateLanguage = async (language) => {
    await i18n.changeLanguage(language);
    changeLanguage(language);
    window.location.reload(false);
  };

  const otherLanguage = stateLanguage === "en" ? "es" : "en";

  return (
    <button
      className="btn btn-sm px-3 py-2"
      onClick={async () => await updateLanguage(otherLanguage)}
      style={{
        background: "rgba(255,255,255,0.15)",
        color: "white",
        fontWeight: "700",
        fontSize: "0.85rem",
        borderRadius: "8px",
        border: "1px solid rgba(255,255,255,0.3)",
        transition: "all 0.3s ease",
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.25)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.15)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {stateLanguage === "en" ? <FlagES /> : <FlagUS />}
      {stateLanguage === "en" ? "ES" : "EN"}
    </button>
  );
};

export default LanguageButton;